import React, { useContext, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import productData from "../Datas/productData";
import "../css/productdetails.scss";
import { CartContext } from "../Component/CartContext";

const ProductDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const product = productData.find((item) => item.id === parseInt(id));
  const { addToCart } = useContext(CartContext);

  const [selectedSize] = useState(product?.size?.[0] || "");
  const [selectedColor, setSelectedColor] = useState(
    product?.colors?.[0] || ""
  );
  const [selectedImage, setSelectedImage] = useState(0);
  const [quantity, setQuantity] = useState(1);
  const [showFullDescription, setShowFullDescription] = useState(false);
  const chainLengths = [
    '16" / 42CM',
    '18" / 45CM',
    '20" / 51CM',
    '22" / 56CM',
    '24" / 60CM',
    '26" / 66CM',
    '28" / 71CM',
  ];
  const [selectedChain, setSelectedChain] = useState(chainLengths[1]);

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  if (!product) {
    return (
      <div className="product-detail">
        <div className="product-detail__not-found">
          <h2>Product not found</h2>
          <Link onClick={toTop} to="/shop">
            Back to Shop
          </Link>
        </div>
      </div>
    );
  }

  const handleAddToCart = () => {
    addToCart(product.id, quantity, selectedSize, selectedColor, selectedChain);
    navigate("/cartpage");
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const setImage = (idx) => {
    setSelectedImage(idx);
  };

  return (
    <div className="product-detail">
      <div className="product-detail__container">
        <div className="product-detail__left">
          <div className="product-detail__thumbnails">
            {product.images.map((img, idx) => (
              <button
                key={idx}
                className={`product-detail__thumbnail ${
                  selectedImage === idx ? "active" : ""
                }`}
                onClick={() => setImage(idx)}
              >
                <img src={img} alt={`${product.name} ${idx + 1}`} />
              </button>
            ))}
          </div>
          <div className="product-detail__main-image">
            <img src={product.images[selectedImage]} alt={product.name} />
          </div>
        </div>

        <div className="product-detail__right">
          <div className="product-detail__breadcrumbs">
            <Link to="/" onClick={toTop}>
              Home
            </Link>
            <span> / </span>
            <Link to="/shop" onClick={toTop}>
              New in
            </Link>
            <span> / </span>
            <Link to="/shop" onClick={toTop}>
              Designer Gemstones
            </Link>
            <span> / </span>
            <span>Hound &amp; Home Jewellery</span>
          </div>

          <div className="product-detail__header">
            <h1>{product.name}</h1>
            <button className="product-detail__wishlist">
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
              </svg>
            </button>
          </div>

          <div className="product-detail__sku">
            SKU: HH-{String(product.id).padStart(3, "0")}
            <span className="product-detail__stock">• Hurry, Only 1 Left!</span>
          </div>

          <div className="product-detail__price">£{product.price}</div>

          <div className="product-detail__options">
            <div className="product-detail__option">
              <label>Chain Length</label>
              <div className="product-detail__chain-options">
                {chainLengths.map((length) => (
                  <button
                    key={length}
                    className={`product-detail__chain-btn ${
                      selectedChain === length ? "active" : ""
                    }`}
                    onClick={() => setSelectedChain(length)}
                  >
                    {length}
                  </button>
                ))}
              </div>
            </div>
            {product.colors && product.colors.length > 0 && (
              <div className="product-detail__option">
                <label>Color</label>
                <div className="product-detail__chain-options">
                  {product.colors.map((color) => (
                    <button
                      key={color}
                      className={`product-detail__chain-btn ${
                        selectedColor === color ? "active" : ""
                      }`}
                      onClick={() => setSelectedColor(color)}
                    >
                      {color}
                    </button>
                  ))}
                </div>
              </div>
            )}
          </div>

          <div className="product-detail__actions">
            <div className="product-detail__quantity">
              <button onClick={() => setQuantity(Math.max(1, quantity - 1))}>
                -
              </button>
              <span>{quantity}</span>
              <button onClick={() => setQuantity(quantity + 1)}>+</button>
            </div>
            <button
              className="product-detail__add-to-cart"
              onClick={handleAddToCart}
            >
              ADD TO CART
            </button>
          </div>

          <div className="product-detail__description">
            <h3>Product Description</h3>
            <div
              className={`product-detail__description-text ${
                showFullDescription ? "expanded" : ""
              }`}
            >
              {product.description
                .slice(0, showFullDescription ? product.description.length : 2)
                .map((para, idx) => (
                  <p key={idx}>{para}</p>
                ))}
            </div>
            <button
              className="product-detail__read-more"
              onClick={() => setShowFullDescription(!showFullDescription)}
            >
              {showFullDescription ? "READ LESS" : "READ MORE"}
            </button>
          </div>

          <div className="product-detail__features">
            {product.Features &&
              product.Features.length > 0 &&
              product.Features.map((feature, idx) => (
                <div key={idx} className="product-detail__feature">
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <path d="M9 12l2 2 4-4" />
                    <path d="M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0z" />
                  </svg>
                  <span>{feature}</span>
                </div>
              ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductDetail;
